// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { Resource } from "./resource.js";
/**
 * Encodes commands to queue that can be executed later
 */
export class CommandBuffer extends Resource {
    static defaultProps = {
        ...Resource.defaultProps
    };
    get [Symbol.toStringTag]() {
        return 'CommandBuffer';
    }
    constructor(device, props) {
        super(device, props, CommandBuffer.defaultProps);
    }
}
//# sourceMappingURL=command-buffer.js.map